import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/modules/Admin/pages/AdminView.vue'),
    meta: {
      title: "Admin Dashboard — cvLab",
    },
  },
]

export default routes
